import { render, staticRenderFns } from "./resources.vue?vue&type=template&id=35ebed9c&scoped=true"
import script from "./resources.vue?vue&type=script&lang=js"
export * from "./resources.vue?vue&type=script&lang=js"
import style0 from "./resources.vue?vue&type=style&index=0&id=35ebed9c&prod&scoped=true&lang=scss"
import style1 from "./resources.vue?vue&type=style&index=1&id=35ebed9c&prod&lang=css"
import style2 from "./resources.vue?vue&type=style&index=2&id=35ebed9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ebed9c",
  null
  
)

export default component.exports